import script from "./OverviewView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewView.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewView.vue?vue&type=style&index=0&id=2cfff549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfff549"]])

export default __exports__